var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCabin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 31,
  height: 31,
  fill: "none",
  viewBox: "0 0 31 31"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#222830",
  strokeLinejoin: "round",
  strokeWidth: 1.938,
  d: "M19.44 16.986h-7.362 7.363Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#222830",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.938,
  d: "M19.828 17.244V28.74h-8.009V17.244s0-.258.388-.258h7.362c.259 0 .388.129.388.258z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#222830",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.938,
  d: "M28.74 27.06a2.04 2.04 0 0 1-2.066 2.067H4.715c-1.033 0-1.937-.904-1.937-2.067 0-1.162.904-2.066 1.937-2.066h7.105v3.746h8.008v-3.746h6.975a2.04 2.04 0 0 1 2.066 2.066z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#222830",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.938,
  d: "M4.715 20.99h7.105v4.004H4.714c-1.033 0-1.937-.904-1.937-2.067 0-1.162.904-2.066 1.937-2.066zM28.74 23.056a2.04 2.04 0 0 1-2.067 2.067h-6.975v-4.004h6.975a2.04 2.04 0 0 1 2.066 2.066z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#222830",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.938,
  d: "M4.715 16.986h7.363c-.258 0-.388.129-.388.258v3.746H4.715c-1.033 0-1.937-.904-1.937-1.937 0-1.034.904-2.067 1.937-2.067M28.61 19.052c0 1.034-.904 1.938-1.937 1.938h-6.846v-3.617s0-.258-.388-.258h7.105c1.033 0 1.937.904 1.937 1.937z",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#222830",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.938,
  d: "M26.673 12.981H4.714c-1.141 0-2.067.897-2.067 2.002 0 1.106.926 2.003 2.067 2.003h21.958c1.142 0 2.067-.897 2.067-2.003 0-1.105-.925-2.002-2.067-2.002"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#222830",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.938,
  d: "M28.74 10.915c0 1.033-.904 1.937-2.066 1.937H4.715a1.956 1.956 0 0 1-1.937-1.679l4.52-2.325h17.567z",
  clipRule: "evenodd"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#222830",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.938,
  d: "M24.736 8.848H7.298l8.913-4.65z",
  clipRule: "evenodd"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#222830",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.938,
  d: "M24.865 8.848h-.13M29.773 11.432l-1.033-.517M7.298 8.848h-.13M2.778 11.302l-1.55.775"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#222830",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.679,
  d: "m8.46 8.073-4.52 2.583V2.002l4.52-.129z",
  clipRule: "evenodd"
})));
export default SvgCabin;